import React from "react";

export default function KeyFeaturesForm({ data, onChange, onNext, onBack }) {
  const groupedFeatures = {
    "Product Identity": [
      ["botanicalIdentity", "Botanical Identity"],
      ["broadSpectrum", "Broad Spectrum"],
      ["greenChemistry", "Green Chemistry"],
      ["agriculture", "Agriculture"],
    ],
    "Traceability": [
      ["organicStewardship", "Organic Stewardship"],
      ["qualityByDesign", "Quality by Design"],
      ["thirdPartyEnabled", "Third Party Enabled"],
      ["nonGmoValidation", "Non-GMO Validation"],
    ],
    "Sustainability": [
      ["climateSmartInterventions", "Climate Smart Interventions"],
      ["livelihoodMission", "Livelihood Mission"],
      ["igar", "IGAR"],
      ["qcafMonitored", "QCAF Monitored"],
    ],
    "Bio-availability": [
      ["comprehensiveSafetyProfile", "Comprehensive Safety Profile"],
      ["bioAvailabilityDifferential", "Bio-Availability Differential"],
      ["realTimeStability", "Real Time Stability"],
      ["activeCellularNutrition", "Active Cellular Nutrition"],
    ],
  };

  return (
    <div>
      <h4 className="text-success">Key Features</h4>

      {Object.entries(groupedFeatures).map(([header, features]) => (
        <div key={header} className="mb-3">
          <h5 className="mt-3 text-success">{header}</h5>
          {features.map(([k, label]) => (
            <div className="form-check" key={k}>
              <input
                id={k}
                type="checkbox"
                className="form-check-input"
                checked={!!data[k]}
                onChange={(e) => onChange(k, e.target.checked)}
              />
              <label className="form-check-label" htmlFor={k}>
                {label}
              </label>
            </div>
          ))}
        </div>
      ))}

      <div className="d-flex justify-content-between mt-3">
        <button type="button" className="btn btn-secondary" onClick={onBack}>
          Back
        </button>
        <button type="button" className="btn btn-primary" onClick={onNext}>
          Next
        </button>
      </div>
    </div>
  );
}
